// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hl-hv-ct[data-v-69d973d7]{height:calc(100% - 110px)}`, "",{"version":3,"sources":["webpack://./../common/components/TemplateVersions/HistroyContainer.vue"],"names":[],"mappings":"AACA,2BACE,yBAAA","sourcesContent":["\n.hl-hv-ct {\n  height: calc(100% - 110px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
